// extracted by mini-css-extract-plugin
export var addButton = "_mt-0";
export var border = "_mt-8";
export var check = "_mt-h";
export var danger = "_mt-6";
export var dropdownContainer = "_mt-1";
export var editModalBody = "_mt-j";
export var footerContainer = "_mt-i";
export var fullWidth = "_mt-a";
export var hide = "_mt-9";
export var icon = "_mt-3";
export var input = "_mt-7";
export var inputFlex = "_mt-b";
export var inputWrapper = "_mt-c";
export var manualFocus = "_mt-5";
export var optionButton = "_mt-4";
export var pillWrapper = "_mt-e";
export var pointer = "_mt-2";
export var showOverflow = "_mt-f";
export var tagsFlex = "_mt-d";
export var xButton = "_mt-g";